import { render, staticRenderFns } from "./IMSwitch.vue?vue&type=template&id=46a656a2&"
import script from "./IMSwitch.vue?vue&type=script&lang=js&"
export * from "./IMSwitch.vue?vue&type=script&lang=js&"
import style0 from "./IMSwitch.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports